export default "__VITE_ASSET__fb8a3250__"